// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_EMAIL_SIGN_UP_LABELS = 'global.emailSignup';

export const GlobalEmailSignUpLabels = {
  global: {
    emailSignup: {
      lbl_SignUp_offerTypeLabel: 'Sign up for emails!',
      lbl_SignUp_signUpForLabel: 'Emails! ',
      lbl_SignUp_getTextLabel: 'GET ',
      lbl_SignUp_nextPurchaseLabel: 'Plus stay updated on special offers, new arrivals & more…',
      lbl_SignUp_joinButtonLabel: 'SIGN UP',
      lbl_SignUp_placeholderText: 'Enter Email Address',
      lbl_SignUp_thankYouTextLabel: 'Thanks for signing up',
      lbl_SignUp_joiningTextLabel: '& connecting with us!',
      lbl_SignUp_confirmationMsgReceiveLabel: 'Your first email is arriving in your inbox soon…',
      lbl_SignUp_extraMessageLabel: ' ',
      lbl_SignUp_footerTextLabel:
        '*By signing up, you agree to provide certain personal information for use by The Children’s Place or Gymboree. You can withdraw your consent at any time. See <a href="/help-center/policies#privacypolicy">Privacy Policy</a>. <a href="/help-center/contact-us">Contact Us</a>: Gymboree, 500 Plaza Drive, Secaucus, NJ 07094, <a href="/">www.gymboree.com</a>.',
      lbl_SignUp_imageAlt: 'Email image alt test',
      lbl_SignUp_submitButtonLabel: 'SUBMIT',
      lbl_SignUp_offTextLabel_suptext: '',
      lbl_SignUp_storeLocatorLabel: 'Store Locator',
      lbl_birthDate_placeholderText: 'Enter BirthDate',
      lbl_err_age_gate:
        "We're sorry! You are not eligible to register on this site. Your information has not been collected.",
      lbl_err_dob_required: 'Please enter your BirthDate',
      lbl_err_age_gate_refer_friend:
        'We’re sorry! You are not eligible to refer a friend on this site. Your information has not been collected.',
      lbl_no_thanks: 'No Thanks',
      lbl_SignUp_noThanks: 'No Thanks',
      lbl_combined_signupEmail: "You're in!! Sign up for emails too!!",
    },
  },
};
